export default "__VITE_ASSET__8bd6a5f1__"